import { jsx as _jsx } from "react/jsx-runtime";
import MUIToggleButton from '@material-ui/lab/ToggleButton';
import withStyles, { createStyles } from '../../core/withStyles';
import Icon from '../Icon';
export const ToggleButtonGroupButton = (props) => {
    const { value, children, icon, disabled } = props;
    const iconElement = typeof icon === 'string' ? _jsx(Icon, { icon: icon }) : icon;
    return (_jsx(MUIToggleButton, Object.assign({}, props, { value: value, disabled: disabled }, { children: icon ? iconElement : children })));
};
const styles = () => createStyles({
    root: {
        flexGrow: 1,
        flexBasis: 0,
        minWidth: 40,
        textTransform: 'none',
        '&:disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'auto',
        },
    },
});
export default withStyles(styles)(ToggleButtonGroupButton);
//# sourceMappingURL=ToggleButtonGroupButton.js.map